module.exports = __webpack_public_path__ + "f54e1ef96c3b7670cd8de1ffdaa7f085.svg";